/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";

import { useDispatch, useSelector } from "react-redux";

import MainImg from "../../assets/landingPages/mainImage.png";
import OgImage from "../../assets/landingPages/homePage/Hero.png";
import { ReactComponent as StarVectorSvg } from "../../assets/landingPages/homePage/starShape.svg";
import { ReactComponent as StarVectorSvgDark } from "../../assets/landingPages/homePage/starShapeDark.svg";
import { ReactComponent as SparkIconLtr } from "../../assets/landingPages/homePage/sparkIconLtr.svg";
import { ReactComponent as HomeHeroEllipsGroupSvg } from "../../assets/landingPages/homePage/homeHeroEllipsGroup.svg";
import RightColorPlatte from "../../assets/landingPages/rightColorPlatte.png";
import LeftColorPlatte from "../../assets/landingPages/leftColorPlatte.png";
import SecSection from "../../assets/landingPages/homePage/firstFeatureSection.png";
import { ReactComponent as SparkIconAr } from "../../assets/landingPages/homePage/sparkArLng.svg";
import { ReactComponent as SparkIconArDark } from "../../assets/landingPages/homePage/sparkArLngDark.svg";
import ThirdSection from "../../assets/landingPages/thirdSection.png";
import FourthSection from "../../assets/landingPages/fourthSection.png";
import { ReactComponent as FeaturesListIcon } from "../../assets/landingPages/homePage/featureLists.svg";
import { ReactComponent as PricingEllipsGroupSvg } from "../../assets/landingPages/homePage/pricingSectionEllipsGroup.svg";
import { ReactComponent as CheckOutlineSvg } from "../../assets/landingPages/tick-circle.svg";
import { ReactComponent as CheckFillSvg } from "../../assets/landingPages/tick-circle-filled.svg";
import TopLeftEllipsCombo from "../../assets/landingPages/topLeftEllips.png";

import { ReactComponent as MostPopular } from "../../assets/landingPages/homePage/mostPopular.svg";
import { ReactComponent as MostPopularAr } from "../../assets/landingPages/homePage/mostPopuAr.svg";

import { gettingPaymentsPalnsList } from "../../redux/slices/paymentStripes/paymentStripesSlice";
import { useNavigate } from "react-router-dom";

import useSettings from "../../hooks/useSettings";
import useLocales from "../../hooks/useLocales";
import toast from "react-hot-toast";
import axios from "axios";
import { Helmet } from "react-helmet";

const baseUrl = process.env.REACT_APP_API_URL;

// Get staeted now button component define here -
const GetStartedtNowBtn = () => {
  const { translate } = useLocales();
  const user = useSelector((state) => state?.user?.user);
  const navigate = useNavigate();
  const getStartedHandler = () => {
    if (user?.token) {
      navigate("/dashboard");
    } else {
      navigate("/auth/signUp");
    }
  };
  return (
    <button
      onClick={() => getStartedHandler()}
      className="rounded-full text-small2_b sm:text-body_copy2_black px-[26px] pt-[9px] pb-[8px] sm:px-10 sm:py-4 sm:pt-[17px] text-white bg-main_color"
    >
      {translate("get_started_now")}
    </button>
  );
};

//Sections left and right text component defined -
const SectionText = (prop) => {
  return (
    <div className="px-6 sm:px-16 lg:px-5">
      <p className="text-main_color text-caption2 sm:text-caption mb-2 ">
        {prop?.topTitle}
      </p>
      <h4 className="text-custom_h5 sm:text-custom_h4 text-heading_color dark:text-color_v1_dark mb-4 sm:mb-8 leading-tight">
        {prop?.titleOne} <span className="text-main_color">{prop.hTitle}</span>{" "}
        {prop?.titleTwo}
      </h4>
      <div>
        {prop?.listsText?.map((item, index) => {
          return (
            <div key={index} className="flex gap-4 mb-1.5 sm:mb-3 ">
              <div className="pt-2">
                <FeaturesListIcon />
              </div>
              <p className="w-full text-small1 sm:text-body_copy1 text-heading_color dark:text-color_v2_dark ">
                {item}
              </p>
            </div>
          );
        })}
      </div>
      <div className="mt-5 sm:mt-10">
        <GetStartedtNowBtn />
      </div>
    </div>
  );
};

const HomePage = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [pageName, setPageName] = useState("");
  const [placeholderVisible, setPlaceholderVisible] = useState(true);

  const [pageNameError, setPageNameError] = useState(null);
  const { themeDirection } = useSettings();
  const { translate, currentLang } = useLocales();
  const [planPeriod, setPlanPeriod] = useState("month");
  const planPeriodSetter = (planPeriod) => {
    setPlanPeriod(planPeriod);
  };

  // section text data
  const firstSectionTextList = [
    `${translate(
      "front_end_pages.home_page.features_section.sec_one_first_line"
    )}`,
    `${translate(
      "front_end_pages.home_page.features_section.sec_one_sec_line"
    )}`,
    `${translate(
      "front_end_pages.home_page.features_section.sec_one_thired_line"
    )}`,
    `${translate(
      "front_end_pages.home_page.features_section.sec_one_four_line"
    )}`,
  ];
  const secondSectionTextList = [
    `${translate(
      "front_end_pages.home_page.features_section.sec_two_first_line"
    )}`,
    `${translate(
      "front_end_pages.home_page.features_section.sec_two_sec_line"
    )}`,
    `${translate(
      "front_end_pages.home_page.features_section.sec_two_thired_line"
    )}`,
    `${translate(
      "front_end_pages.home_page.features_section.sec_two_four_line"
    )}`,
  ];
  const thirdSectionTextList = [
    `${translate(
      "front_end_pages.home_page.features_section.sec_thered_first_line"
    )}`,
    `${translate(
      "front_end_pages.home_page.features_section.sec_two_sec_line"
    )}`,
    `${translate(
      "front_end_pages.home_page.features_section.sec_two_thired_line"
    )}`,
    `${translate(
      "front_end_pages.home_page.features_section.sec_thered_four_line"
    )}`,
  ];

  const [plans, setPlans] = useState();
  const inputRef = useRef(null);

  const getPaymentStripeData = useSelector(
    (state) => state?.paymentStripes?.getPaymentsPlansList
  );
  const {
    getPaymentsPalnsListError,
    getPaymentsPalnsListsuccess,
    getPaymentsPalnsListLoading,
    getPaymentsPalnsListErrorMsg,
  } = useSelector((state) => state?.paymentStripes);

  const [allCardsInfo, setAllCardsInfo] = useState([]);

  useEffect(() => {
    if (getPaymentsPalnsListError) {
      navigate("/500");
    }
  }, [getPaymentsPalnsListLoading]);

  useEffect(() => {
    gettingPaymentsPlans();
  }, []);
  const gettingPaymentsPlans = () => {
    dispatch(gettingPaymentsPalnsList());
  };
  useEffect(() => {
    if (getPaymentStripeData?.status === "success") {
      setAllCardsInfo(getPaymentStripeData.result);
      setPlans(
        getPaymentStripeData.result?.filter(
          (plan) =>
            plan.name === "Free Plan" || plan.name === "Premium Plan (Paid)"
        )
      );
    }
  }, [getPaymentStripeData?.status === "success"]);
  const user = useSelector((state) => state?.user?.user);

  const [nameLoading, setNameLoading] = useState(false);

  const getStartedHandlerCTA = async () => {
    if (user?.token) {
      if (pageName) {
        if (user?.twofactor?.pageName === pageName) {
          setPageNameError(null);
          navigate("/dashboard");
        } else {
          setPageNameError({
            value: "pageNameNotMatch",
            message: "Enter Correct Page Name",
          });
        }
      } else {
        setPageNameError(null);
        navigate("/dashboard");
      }
    } else {
      setPageNameError(null);
      if (pageName) {
        await validatePageName(pageName);
      } else {
        navigate(`/auth/signUp`);
      }
    }
  };

  useEffect(() => {
    if (pageNameError?.value === "pageNameNotMatch") {
      toast.error(pageNameError?.message);
    }
  }, [pageNameError]);

  const validatePageName = async (pageName) => {
    const data = {
      pageName: pageName,
    };
    const path = "/api/user/validatePageName";
    const url = baseUrl + path;
    setNameLoading(true);
    try {
      const response = await axios.post(url, data);
      setNameLoading(false);
      if (response.data.status === true) {
        navigate(`/auth/signUp/${pageName}`);
      } else {
        setNameLoading(false);
        navigate(`/auth/login/${pageName}`);
      }
      return response?.data;
    } catch (error) {
      setNameLoading(false);
      return error;
    }
  };

  //  default values for pageName
  const user_data = useSelector(
    (state) => state?.adminUser?.viewUserData?.user_data
  );

  useEffect(() => {
    if (user?.token) {
      setPageName(user?.twofactor?.pageName);
    }
  }, [user]);

  useEffect(() => {
    // Function to handle clicks outside the input field
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        // Click is outside the input field, so show the placeholder
        setPlaceholderVisible(true);
      }
    };

    // Adding event listener to detect clicks anywhere on the document
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup function to remove event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleInputClick = () => {
    setPlaceholderVisible(false); // Hide placeholder when clicked
  };

  return (
    <>
      {/* Helmet use for set meta tags in head */}
      <Helmet>
        <meta charSet="utf-8" />
        <title>Bil.Bio</title>
        <meta name="description" content="Bil.Bio" />
        <meta property="og:title" content="Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content={currentLang?.value} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      {/* Hero Section  */}
      <section
        className={`flex  bg-[#fbf7f7] dark:bg-dark-primary pt-[24px]  items-center justify-center relative`} /* pt-[93px] mt-[93px]*/
      >
        <div className="absolute right-0 bottom-0 ">
          <HomeHeroEllipsGroupSvg className="h-[16rem] w-auto max-h-[16rem] sm:max-h-[493px] md:max-h-[350px] xl:max-h-[470px] sm:h-auto" />
        </div>
        <div className="hidden xl:block absolute lg:left-6 xl:left-20 lg:top-16 xl:top-40">
          {darkMode ? (
            <StarVectorSvgDark className="lg:h-10 xl:h-14" />
          ) : (
            <StarVectorSvg className="lg:h-10 xl:h-14" />
          )}
        </div>
        <div className="2xl:max-w-screen-xl xl:max-w-screen-lg">
          <div className="">
            <div
              className={`px-3 sm:px-9 flex h-full flex-col lg:flex-row gap-12 sm:gap-16 lg:gap-6 items-center lg:pt-14 lg:py-16 xl:pt-16 xl:py-20 2xl:pt-14 2xl:py-24 pt-[60px] pb-[70px] relative`}
            >
              <div className="w-full lg:w-[60%]">
                {currentLang?.value !== "ar" ? (
                  <h1 className="text-custom_h4 sm:text-custom_h3 md:text-custom_h2 2xl:text-custom_h1 text-heading_color dark:text-color_v1_dark mb-3">
                    {translate("main_title_part_one")}
                    <br className="hidden sm:block" />
                    <span className="text-main_color relative">
                      {translate("main_title_part_two")}
                    </span>
                  </h1>
                ) : (
                  <h1 className="text-custom_h4 relative pe-6 xsml:pe-12 sm:pe-0 sm:text-custom_h3 md:text-custom_h2 2xl:text-custom_h1 text-heading_color dark:text-color_v1_dark mb-3">
                    <span className="relative max-w-fit flex">
                      {darkMode ? (
                        <SparkIconArDark className="h-7 absolute -left-6 smm:-left-[25px] sml:-left-[50px] lg:-left-[35px] smm:-top-[0.5rem] -top-[0.5rem] " />
                      ) : (
                        <SparkIconAr className="h-7 absolute -left-6 smm:-left-[25px] sml:-left-[50px] lg:-left-[35px] smm:-top-[0.5rem] -top-[0.5rem] " />
                      )}
                      {translate("main_title_part_one")}
                    </span>
                    <span className="text-main_color relative">
                      <br className="hidden smm:block md:block xl:hidden" />
                      &nbsp;
                      {translate("main_title_part_two")}
                    </span>
                  </h1>
                )}
                <p className="text-body_copy_medium_color dark:text-color_v2_dark text-small2 sm:text-body_copy1">
                  {translate(
                    "front_end_pages.home_page.hero_section.sub_title"
                  )}
                </p>
                <div
                  className={`dark:bg-dark-primary mt-[30px] sm:mt-14 rounded-full p-2 bg-white ${
                    darkMode ? "" : "shadow-box_shadow_1"
                  } flex justify-between w-full md:w-11/12 lg:w-11/12 xl:w-4/5 items-center border border-[#f6f1eb] dark:border-color_dark dark:border`}
                >
                  <div
                    className="flex items-center pl-[10px] sm:pl-[20px] px-1 sm:px-2 w-full"
                    ref={inputRef}
                  >
                    <p className="text-main_color text-small2_b sm:text-small1_bold md:text-body_copy1_b xl:text-custom_h6 px-1">
                      bil.bio/
                    </p>
                    <input
                      type="text"
                      defaultValue={pageName || ""}
                      onChange={(e) => setPageName(e.target.value)}
                      // placeholder="your pagename"
                      onClick={handleInputClick}
                      placeholder={placeholderVisible ? "your pagename" : ""}
                      className="dark:text-color_v1_dark dark:caret-white placeholder:dark:text-color_v1_dark dark:bg-dark-primary focus:outline-none text-heading_color placeholder:text-heading_color text-small2 sm:text-small1 md:text-body_copy1 xl:text-custom_h6r w-full lg:w-full"
                    />
                  </div>
                  <button
                    onClick={() => getStartedHandlerCTA()}
                    className="rounded-full whitespace-nowrap px-[26px] pt-[9px] pb-[8px] sm:px-8 sm:pt-[9px] sm:pb-[8px]  xl:px-10 xl:py-3.5 text-white bg-main_color text-small2_b sm:text-small1_bold md:text-body_copy2_black lg:text-small1_bold xl:text-body_copy2_b"
                  >
                    {translate(`descriptions.get_started`)}
                  </button>
                </div>
              </div>
              <div className="w-full lg:w-[40%] flex justify-center xl:justify-end relative">
                <div className="relative">
                  <div className="absolute xsmm:-left-16 -left-20 sm:-left-32 lg:-left-24 z-30 bottom-14 sm:bottom-[93px]">
                    <img
                      className="xsmm:max-h-[1.8rem] max-h-[2rem]  drop-shadow-lg sm:max-h-[4rem] lg:max-h-[2.4rem] xl:max-h-[2.6rem]"
                      src={LeftColorPlatte}
                      alt="..."
                      title="..."
                    />
                  </div>
                  <div className="absolute xsmm:-right-[4.5rem] -right-[5.3rem] sm:-right-32 lg:-right-20 xl:-right-24 z-30 top-24 sm:top-[162px]">
                    <img
                      className="xsmm:max-h-[1.8rem] max-h-[2rem] drop-shadow-lg sm:max-h-[4rem] lg:max-h-[2.4rem] xl:max-h-[2.6rem]"
                      src={RightColorPlatte}
                      alt="..."
                      title="..."
                    />
                  </div>
                  <img
                    src={MainImg}
                    className="xsmm:max-h-[24rem] max-h-[21rem] sm:max-h-[38rem] lg:max-h-[32rem] xl:max-h-[35rem] 2xl:max-h-[38rem] z-20"
                    alt="..."
                    title="..."
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featurs Sections  */}
      <section className="flex justify-center  dark:bg-dark-secondary">
        <div className="2xl:max-w-screen-xl xl:max-w-screen-lg  ">
          <div className="flex flex-col lg:flex-row px-0 gap-12 lg:gap-6 pt-[70px] pb-[42px] lg:pb-24 sm:pt-[164px] justify-start items-center">
            <div className="w-full hidden lg:flex justify-center">
              <img
                src={SecSection}
                alt="Create BioLink"
                title={"Create BioLink"}
              />
            </div>
            <div className="w-full lg:mb-[50px]">
              <SectionText
                topTitle={translate(
                  "front_end_pages.home_page.features_section.create"
                )}
                titleOne={translate(
                  "front_end_pages.home_page.features_section.create_your"
                )}
                hTitle={translate(
                  "front_end_pages.home_page.features_section.unique"
                )}
                titleTwo={translate(
                  "front_end_pages.home_page.features_section.biolink"
                )}
                listsText={firstSectionTextList}
              />
            </div>
            <div className="w-full px-5 flex lg:hidden justify-center">
              <img
                src={SecSection}
                alt="Create BioLink"
                title={"Create BioLink"}
              />
            </div>
          </div>
        </div>
      </section>
      <section className="flex justify-center  dark:bg-dark-secondary">
        <div className="max-w-screen-2xl ">
          <div
            className={`flex flex-col lg:flex-row smm:px-8 sm:px-10 md:px-10 lg:ps-12 xl:ps-44 lg:pe-6 xl:pe-16 gap-12 lg:gap-6 py-12 lg:py-24 justify-center items-center`}
          >
            <div className="w-full">
              <SectionText
                topTitle={translate(
                  "front_end_pages.home_page.features_section.customize"
                )}
                titleOne={translate(
                  "front_end_pages.home_page.features_section.design"
                )}
                hTitle={translate(
                  "front_end_pages.home_page.features_section.exceptional"
                )}
                titleTwo={translate(
                  "front_end_pages.home_page.features_section.biolink"
                )}
                listsText={secondSectionTextList}
              />
            </div>
            <div className="w-full px-5 flex justify-center lg:justify-start">
              <img
                src={ThirdSection}
                alt="Design Biolink"
                title="Design Biolink"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="flex justify-center  dark:bg-dark-secondary">
        <div className="2xl:max-w-screen-xl xl:max-w-screen-lg ">
          <div className="flex flex-col lg:flex-row smm:px-9 gap-8 py-20 lg:pt-[97.3px] lg:pb-[160px] items-center">
            <div className="w-full hidden lg:flex justify-end">
              <img
                src={FourthSection}
                alt="Share BioLink"
                title={"Share BioLink"}
              />
            </div>
            <div className="w-full">
              <SectionText
                topTitle={translate(
                  "front_end_pages.home_page.features_section.share"
                )}
                titleOne={translate(
                  "front_end_pages.home_page.features_section.add_your_biolink_to_your"
                )}
                hTitle={translate(
                  "front_end_pages.home_page.features_section.social_media"
                )}
                titleTwo={translate(
                  "front_end_pages.home_page.features_section.handles"
                )}
                listsText={thirdSectionTextList}
              />
            </div>
            <div className="w-full px-7 flex lg:hidden justify-center">
              <img
                src={FourthSection}
                alt="Share BioLink"
                title={"Share BioLink"}
              />
            </div>
          </div>
        </div>
      </section>
      {/* End Featurs Sections  */}
      {/* Pricing Sections  */}
      <section className="flex justify-center bg-[#fbf7f7]  dark:bg-dark-primary relative">
        <div className="absolute right-0 top-0  z-0">
          <PricingEllipsGroupSvg className="h-64 w-[180px] sm:h-96 sm:w-60 2xl:w-[370px] 2xl:h-[455px]" />
        </div>
        <div className="flex w-full 2xl:max-w-screen-xl xl:max-w-screen-lg">
          <div className="w-full py-20 pb-5 lg:py-[130px] lg:pb-5 relative px-5 sm:px-20 lg:px-6 ">
            <div className="text-center z-10">
              <p className="text-main_color text-caption2 sm:text-caption mb-2 ">
                {translate(
                  "front_end_pages.home_page.pricing_section.subscription"
                )}
              </p>
              <h3 className="text-custom_h5 sm:text-custom_h3 smm:px-7 text-heading_color dark:text-color_v1_dark mb-5 sm:mb-8 md:mb-5 ">
                {translate(
                  "front_end_pages.home_page.pricing_section.choose_a"
                )}{" "}
                <span className="text-main_color">
                  {translate("front_end_pages.home_page.pricing_section.plan")}
                </span>{" "}
                {translate(
                  "front_end_pages.home_page.pricing_section.that_works_for_you"
                )}
              </h3>
            </div>
            <div className="flex justify-center z-10">
              <div
                className={`rounded-full flex ${
                  themeDirection === "rtl" ? "flex-row-reverse" : ""
                } py-[5px] px-[7px] bg-white dark:bg-dark-primary dark:border-color_dark dark:border w-fit items-center ${
                  darkMode ? "" : "shadow-shadow_1"
                } z-10`}
              >
                <button
                  onClick={() => planPeriodSetter("month")}
                  className={`cursor-pointer transition ease-in-out ${
                    planPeriod === "month"
                      ? "py-[10px] px-[30px] rounded-full border border-heading_color dark:border-color_v1_dark text-heading_color dark:text-color_v1_dark text-small3_b sm:text-small1_bold"
                      : "py-[10px] px-[30px] rounded-full  text-dark_bg_v5 text-small3_b sm:text-small1_bold opacity-60"
                  } `}
                >
                  {translate(
                    "front_end_pages.home_page.pricing_section.monthly"
                  )}
                </button>
                <button
                  onClick={() => planPeriodSetter("annual")}
                  className={`cursor-pointer transition ease-in-out ${
                    planPeriod === "annual"
                      ? "py-[10px] px-[30px] rounded-full border border-heading_color dark:border-color_v1_dark text-heading_color dark:text-color_v1_dark text-small3_b sm:text-small1_bold"
                      : "py-[10px] px-[30px] rounded-full  text-dark_bg_v5 text-small3_b sm:text-small1_bold opacity-60"
                  } `}
                >
                  {translate(
                    "front_end_pages.home_page.pricing_section.annual"
                  )}
                </button>
              </div>
            </div>
            <div
              className={`flex flex-col lg:flex-row ${
                themeDirection === "rtl" ? "lg:flex-row-reverse" : ""
              } gap-[28px] md:gap-[33px] justify-center items-center py-12 lg:py-16 lg:pb-[124px] z-10`}
            >
              {plans?.map((item, i) => {
                return item?.name === "Free Plan" ? (
                  <div
                    key={i}
                    className={`${
                      darkMode ? "" : "shadow-box_shadow_1"
                    } w-full relative hover:scale-105 p-[25px] sm:p-[30px] rounded-2xl bg-white dark:bg-dark-secondary max-w-md md:max-w-md md:min-w-[27rem]`}
                  >
                    <div className="text-body_copy2_black text-body_copy1_color dark:text-color_v1_dark">
                      {translate("front_end_pages.pricing.free_plan")}
                    </div>
                    <div className="flex gap-2 mt-2.5 mb-[15px] items-center">
                      <div className="text-custom_h4 text-heading_color dark:text-color_v1_dark">
                        {planPeriod === "annual" && <>${item?.annual_price}</>}
                        {planPeriod === "month" && <>${item?.monthly_price}</>}
                      </div>
                    </div>
                    <div className="text-dark_bg_v5 dark:text-color_v2_dark text-small3 md:text-body_copy2 mb-[25px] md:mb-10 capitalize">
                      {/* {item?.description} */}
                      {translate("package_suitable_people")}
                    </div>

                    <div className="hidden md:block text-heading_color dark:text-color_v1_dark text-body_copy2_black mb-[15px]">
                      {/* What’s included: */}
                      {translate(
                        "front_end_pages.home_page.pricing_section.what_included"
                      )}
                      :
                    </div>
                    <div className="flex flex-col gap-2.5">
                      <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-body_copy1_color dark:text-color_v2_dark">
                        <CheckOutlineSvg />
                        {/* Unlimited Biolink Pages */}
                        {translate(
                          "front_end_pages.home_page.pricing_section.unlimited_biolink_pages"
                        )}
                      </div>
                      <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-body_copy1_color dark:text-color_v2_dark">
                        <CheckOutlineSvg />
                        {/* Unlimited Biolink Blocks */}
                        {translate(
                          "front_end_pages.home_page.pricing_section.unlimited_biolink_blocks"
                        )}
                      </div>
                      <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-body_copy1_color dark:text-color_v2_dark">
                        <CheckOutlineSvg />
                        {/* 25 Biolink Pages */}
                        {translate(
                          "front_end_pages.home_page.pricing_section.bio_pages"
                        )}
                      </div>
                      <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-body_copy1_color dark:text-color_v2_dark">
                        <CheckOutlineSvg />
                        {/* SEO Features */}
                        {translate(
                          "front_end_pages.home_page.pricing_section.seo_feature"
                        )}
                      </div>
                      <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-body_copy1_color dark:text-color_v2_dark">
                        <CheckOutlineSvg />
                        {/* Brandings */}
                        {translate(
                          "front_end_pages.home_page.pricing_section.brandings"
                        )}
                      </div>

                      <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-body_copy1_color dark:text-color_v2_dark">
                        <CheckOutlineSvg />
                        {/* 24*7 Customer Support */}
                        {translate(
                          "front_end_pages.home_page.pricing_section.customer_support"
                        )}
                      </div>
                    </div>
                    <button
                      onClick={() => {
                        navigate(
                          `/pricing/payment/PaymentDetailsFormPage/${planPeriod}/${item?.product_id?._id}`
                        );
                      }}
                      className="w-full text-center mt-[25px] py-[6px] md:pt-[13px] md:pb-[12px] text-white rounded-full bg-gradient-to-br from-[#f8765c] to-[#f7554b] text-small3_b md:text-small1_bold"
                    >
                      {translate("choose_plan_cap")}
                    </button>
                  </div>
                ) : null;
              })}
              {plans?.map((item, i) => {
                return item?.name === "Premium Plan (Paid)" ? (
                  <div
                    key={i}
                    className={`${
                      darkMode ? "" : "shadow-box_shadow_1"
                    } w-full relative hover:scale-105 p-[25px] sm:p-[30px] rounded-2xl bg-gradient-to-br from-[#f8765c] to-[#f7554b] text-white max-w-md md:max-w-md md:min-w-[27rem]`}
                  >
                    {currentLang?.value !== "ar" ? (
                      <MostPopular className="absolute hidden lg:block lg:-top-[5.6rem] xl:-top-20 2xl:-top-20 lg:-right-8 xl:-right-24 2xl:-right-32 lg:max-h-28 xl:max-h-28 2xl:max-h-28 lg:max-w-[6.5rem] xl:max-w-fit 2xl:max-w-full lg:-rotate-12 xl:rotate-0" />
                    ) : (
                      <MostPopularAr className="absolute hidden lg:block lg:-top-[5.6rem] xl:-top-20 2xl:-top-20 lg:-right-8 xl:-right-24 2xl:-right-36 lg:max-h-28 xl:max-h-28 2xl:max-h-[110px] lg:max-w-[6.5rem] xl:max-w-fit 2xl:max-w-full lg:-rotate-12 xl:rotate-0" />
                    )}

                    <div className="text-body_copy2 mb-2 text-white">
                      {translate("front_end_pages.pricing.premium_plan_paid")}
                    </div>
                    <div className="flex gap-2 mb-[15px] items-center">
                      <div className="text-custom_h4">
                        {planPeriod === "annual" && <>${item?.annual_price}</>}
                        {planPeriod === "month" && <>${item?.monthly_price}</>}
                      </div>
                    </div>
                    <div className="text-white text-small3 md:text-body_copy2 mb-[25px] md:mb-10 capitalize">
                      {item?.description}
                    </div>

                    <div className="hidden md:block text-body_copy2_black mb-[15px]">
                      {/* What’s included: */}
                      {translate(
                        "front_end_pages.home_page.pricing_section.what_included"
                      )}
                      :
                    </div>
                    <div className="flex flex-col gap-2.5">
                      <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-white">
                        <CheckFillSvg />
                        {translate(
                          "front_end_pages.home_page.pricing_section.unlimited_biolink_pages"
                        )}
                      </div>
                      <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-white">
                        <CheckFillSvg />
                        {translate(
                          "front_end_pages.home_page.pricing_section.unlimited_biolink_blocks"
                        )}
                      </div>
                      <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-white">
                        <CheckFillSvg />
                        {translate(
                          "front_end_pages.home_page.pricing_section.bio_pages"
                        )}
                      </div>
                      <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-white">
                        <CheckFillSvg />
                        {translate(
                          "front_end_pages.home_page.pricing_section.seo_feature"
                        )}
                      </div>
                      <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-white">
                        <CheckFillSvg />
                        {translate(
                          "front_end_pages.home_page.pricing_section.brandings"
                        )}
                      </div>

                      <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-white">
                        <CheckFillSvg />
                        {translate(
                          "front_end_pages.home_page.pricing_section.customer_support"
                        )}
                      </div>
                    </div>
                    <button
                      onClick={() => {
                        navigate(
                          `/pricing/payment/PaymentDetailsFormPage/${planPeriod}/${item?.product_id?._id}`
                        );
                      }}
                      className="w-full text-center mt-[25px] py-[6px] md:pt-[13px] md:pb-[12px] text-heading_color rounded-full bg-white text-small3_b md:text-small1_bold"
                    >
                      {translate("choose_plan_cap")}
                    </button>
                  </div>
                ) : null;
              })}
            </div>
          </div>
        </div>
      </section>

      {/* Create Page Name Sections  */}
      <section className="justify-center flex dark:bg-dark-secondary">
        <div className="flex w-full max-w-screen-2xl ">
          <div className="w-full xsmm:px-3 xsml:px-5 smm:px-10 lg:px-20 xl:px-44 py-[70px] pb-[122px] md:pb-24 md:py-24 lg:pb-[162px] ">
            <div className="w-full relative text-center  xsmm:rounded-2xl lg:rounded-[2rem]  bg-gradient-to-br from-[#f8765c] to-[#f7554b] xsmm:p-3 xsmm:py-[55px] xsml:p-4 xsml:py-[55px] smm:p-7 smm:py-[55px] sm:p-10 sm:py-[55px] lg:py-20 p-16">
              <div className="absolute left-0 top-0 z-0">
                <img
                  className="xsmm:h-32 lg:h-48"
                  src={TopLeftEllipsCombo}
                  alt=""
                />
              </div>
              <h5 className="text-white text-body_copy2_black sm:text-custom_h5 xsmm:mb-4 smm:mb-6 sm:mb-8 mb-10">
                {translate(
                  "front_end_pages.home_page.create_page_section.start_creating_your_exclusive"
                )}
                {translate(
                  "front_end_pages.home_page.create_page_section.bilbio"
                )}{" "}
                <br className="xsmm:hidden sm:block" />
                <span className="text-heading_color">
                  {translate(
                    "front_end_pages.home_page.create_page_section.biolink_url"
                  )}
                </span>{" "}
                {translate("front_end_pages.home_page.create_page_section.now")}
                !
              </h5>
              <div className="flex justify-center">
                <div className="rounded-full p-1 bg-white shadow-shadow_1 flex justify-between w-full md:w-11/12 lg:w-11/12 xl:w-3/5 items-center border border-[#f6f1eb]">
                  <div className="flex items-center px-1 sm:px-2 w-full">
                    <p className="text-main_color text-small2_b sm:text-custom_h6 px-1">
                      bil.bio/
                    </p>
                    <input
                      type="text"
                      defaultValue={pageName || ""}
                      onChange={(e) => setPageName(e.target.value)}
                      // placeholder="your pagename"
                      onClick={handleInputClick}
                      placeholder={placeholderVisible ? "your pagename" : ""}
                      className="focus:outline-none text-heading_color placeholder:text-heading_color text-small2 sm:text-custom_h6r w-full lg:w-full"
                    />
                  </div>
                  <button
                    onClick={() => getStartedHandlerCTA()}
                    className="rounded-full whitespace-nowrap px-[26px] pt-[9px] pb-[8px] sm:px-10 sm:pt-[17px] sm:pb-[16px] text-white bg-dark_bg_v1 text-small3_b sm:text-body_copy2_b"
                  >
                    {translate(`descriptions.get_started`)}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePage;
